import React from 'react';
import { FormattedMessage } from 'react-intl';

export function sectionHead(message, top = false) {
    const offset = top ? '' : 'topOffset15';
    return {
        label: (
            <div className={`section-title  ${offset}`}>
                <FormattedMessage {...message} />
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/worker/tabs/_common.jsx